// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"fce399e5","146":"13db2dcf","211":"57c837f8","404":"a2ec7266","449":"1934da51","494":"a5bea0e5","673":"5af5fed3","819":"22d79799","830":"5fe76183"}[chunkId] + ".chunk.js";
};